import React, { useState, useEffect } from "react";
import { WorkshopPage, BeyondSchoolPage, MentoringPage } from "./Pages";
import KooperationPage from "./KooperationPage";
import Anmeldung from "./Anmeldung";
import { createClient } from "@supabase/supabase-js";
const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_KEY
);

const COMPANY_DATA = [
  {name:"Stadtmüller Bedachungen GmbH",branche:"Dachdecker / Baustoffhandel",kategorie:"Handwerk / Bau",web:"https://www.stadtmueller-bedachungen.de"},
  {name:"Brenner GmbH Elektrotechnik",branche:"Elektrotechnik / Antriebstechnik",kategorie:"Handwerk / Technik",web:"https://www.brenner-gmbh.de"},
  {name:"GS Wärmesysteme GmbH",branche:"Heizung, Sanitär, Photovoltaik",kategorie:"Handwerk / Technik",web:"https://www.gs-waermesysteme.de"},
  {name:"SIMA-Bau Siegler GmbH",branche:"Metallbedachungen / Fassaden",kategorie:"Handwerk / Bau",web:"https://www.sima-bau.de"},
  {name:"rh Construction GmbH",branche:"Bauunternehmen / Innenausbau",kategorie:"Handwerk / Bau",web:"https://www.rhconstruction.de"},
  {name:"Köbig",branche:"Baustoffhandel",kategorie:"Handel",web:"https://www.koebig.de"},
  {name:"Bürstadt Furniture GmbH",branche:"Möbelproduktion",kategorie:"Industrie / Produktion",web:"https://www.buerstadt-furniture.de"},
  {name:"BASF",branche:"Chemieindustrie",kategorie:"Industrie / Produktion",web:"https://www.basf.com"},
  {name:"Autohaus Jakob & Morweiser",branche:"Autohaus / SEAT",kategorie:"Automotive",web:"https://www.jakob-morweiser.de"},
  {name:"Auto-Kohl GmbH",branche:"Autohaus / Opel",kategorie:"Automotive",web:"https://www.autokohl-buerstadt.de"},
  {name:"REWE Bürstadt",branche:"Lebensmitteleinzelhandel",kategorie:"Handel",web:"https://www.rewe.de"},
  {name:"Agrarmarkt Engert",branche:"Garten- & Tierfachmarkt",kategorie:"Handel",web:"https://www.agrarmarkt-engert.de"},
  {name:"Brillenschlange",branche:"Augenoptik",kategorie:"Handel",web:"https://www.brillenschlange-buerstadt.de"},
  {name:"Bäckerei Andreas Blüm",branche:"Bäckerei / Handwerk",kategorie:"Handel",web:"https://www.baeckerbluem.de"},
  {name:"Back- und Brauhaus Drayß",branche:"Gastronomie / Bäckerei",kategorie:"Gastronomie",web:"https://www.back-und-brauhaus.de"},
  {name:"VR Bank Ried-Überwald",branche:"Genossenschaftsbank",kategorie:"Finanz",web:"https://www.meinevrbank.de"},
  {name:"Sparkasse Worms-Alzey-Ried",branche:"Bank / Sparkasse",kategorie:"Finanz",web:"https://www.sparkasse-worms-alzey-ried.de"},
  {name:"R+V Versicherung",branche:"Versicherung",kategorie:"Finanz",web:"https://www.ruv.de"},
  {name:"Immowien GmbH",branche:"Immobilien / Makler",kategorie:"Finanz",web:"https://www.immowien.de"},
  {name:"Reisebüro Friedle",branche:"Tourismus",kategorie:"Tourismus",web:"https://www.reisebuero-friedle.de"},
  {name:"Kanzlei Sally Uhlmann",branche:"Rechtsanwältin & Notarin",kategorie:"Recht",web:"https://www.kanzleiuhlmann.de"},
  {name:"Kreisvolkshochschule Bergstraße",branche:"Erwachsenenbildung",kategorie:"Bildung / Soziales",web:"https://www.kvhs-bergstrasse.de"},
  {name:"Caritas Bürstadt",branche:"Soziale Arbeit",kategorie:"Bildung / Soziales",web:"https://www.caritas.de"},
  {name:"Mittendrin Bürstadt",branche:"Stadtentwicklung",kategorie:"Bildung / Soziales",web:"https://www.buerstadt-mittendrin.de"},
  {name:"Kita St. Peter Bürstadt",branche:"Kindertagesbetreuung",kategorie:"Bildung / Soziales",web:null},
];

const TEAM_MEMBERS = [
  {name:"Constantin Morweiser",li:"https://www.linkedin.com/in/constantin-morweiser-ab25bb2a2/"},
  {name:"Laurin Morweiser",li:"https://www.linkedin.com/in/laurin-morweiser-962015287/"},
  {name:"Yannick Ulpins",li:"https://www.linkedin.com/in/yannick-ulpins-university-mannheim-bwl/"},
  {name:"Lars Dommermuth",li:"https://www.linkedin.com/in/lars-dommermuth-8a1bb6363/"},
  {name:"Edgar Schwarze",li:null},
  {name:"Luisa Lurg",li:"https://www.linkedin.com/in/luisa-lurg-a20646382/"},
  {name:"Sophia Lurg",li:null},
  {name:"Franka Thierfelder",li:null},
  {name:"Julius Keinz",li:"https://www.linkedin.com/in/julius-keinz-25533630b/"},
  {name:"Anna Röß",li:null},
  {name:"Hannah Winkenbach",li:null},
  {name:"Philipp Reiber",li:"https://www.linkedin.com/in/philipp-reiber-9495132a9/"},
  {name:"Lea Habel",li:null},
  {name:"Luca Ost",li:null},
];

const G="#1a3a2a",LIME="#c8f060",CREAM="#f5f0e8",WARM="#e8d8c0",MUTED="#6b6b5a";

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;900&display=swap');
  *{box-sizing:border-box;margin:0;padding:0;}
  body{font-family:'Inter',sans-serif;background:${CREAM};color:${G};}
  ::-webkit-scrollbar{width:6px}::-webkit-scrollbar-track{background:${CREAM}}::-webkit-scrollbar-thumb{background:rgba(26,58,42,.3);border-radius:3px}
  .nav{position:fixed;top:0;left:0;right:0;z-index:100;display:flex;align-items:center;justify-content:space-between;padding:.9rem 5vw;background:rgba(245,240,232,.95);backdrop-filter:blur(12px);border-bottom:1px solid rgba(26,58,42,.1)}
  .nav-logo{display:flex;align-items:center;gap:.7rem;cursor:pointer}
  .nav-logo img{height:3rem;width:auto}
  .nav-logo-text{font-family:'Inter',sans-serif;font-size:1.2rem;color:${G}}
  .nav-logo-text span{color:#7ab828}
  .nav-links{display:flex;gap:1.5rem}
  .nav-link{font-size:.82rem;font-weight:500;letter-spacing:.04em;text-transform:uppercase;color:${MUTED};cursor:pointer;border:none;background:none;transition:color .2s;padding:.3rem 0}
  .nav-link:hover{color:${G}}
  .nav-cta{background:${G};color:${LIME};padding:.5rem 1.2rem;border-radius:2rem;font-size:.8rem;font-weight:700;letter-spacing:.04em;text-transform:uppercase;border:none;cursor:pointer;transition:all .2s}
  .nav-cta:hover{background:#2d5c41;transform:translateY(-1px)}
  .page{padding-top:4.5rem;min-height:100vh}
  .hero{display:grid;grid-template-columns:1fr 1fr;min-height:calc(100vh - 4.5rem)}
  .hero-l{display:flex;flex-direction:column;justify-content:center;padding:5vw 4vw 5vw 8vw}
  .hero-h1{font-family:'Inter',sans-serif;font-size:clamp(2.5rem,4.5vw,4.8rem);line-height:1.06;letter-spacing:-.02em;color:${G};margin-bottom:1.2rem}
  .hero-h1 em{font-style:italic;color:#7ab828}
  .hero-sub{font-size:1rem;line-height:1.7;color:${MUTED};max-width:42ch;margin-bottom:2rem}
  .hero-btns{display:flex;gap:.8rem;flex-wrap:wrap}
  .btn-primary{background:${G};color:${LIME};padding:.8rem 1.6rem;border-radius:2rem;font-size:.88rem;font-weight:700;border:none;cursor:pointer;transition:all .2s}
  .btn-primary:hover{background:#2d5c41;transform:translateY(-2px);box-shadow:0 8px 24px rgba(26,58,42,.2)}
  .btn-secondary{background:transparent;color:${G};padding:.8rem 1.6rem;border-radius:2rem;font-size:.88rem;font-weight:600;border:1.5px solid ${G};cursor:pointer;transition:all .2s}
  .btn-secondary:hover{background:${G};color:${LIME}}
  .hero-stats{display:flex;gap:2rem;margin-top:2.5rem;padding-top:2rem;border-top:1px solid rgba(26,58,42,.12)}
  .stat-n{font-family:'Inter',sans-serif;font-size:2.4rem;color:${G};line-height:1}
  .stat-n span{color:#7ab828}
  .stat-l{font-size:.76rem;color:${MUTED};margin-top:.25rem}
  .hero-r{background:${G};display:flex;align-items:flex-end;position:relative;overflow:hidden}
  .hero-r-inner{padding:2.5rem 2.5rem 3.5rem;position:relative;z-index:2;width:100%}
  .hero-img{width:100%;height:100%;object-fit:cover;position:absolute;top:0;left:0;opacity:.7}
  .hero-quote{font-family:'Inter',sans-serif;font-size:clamp(1.3rem,2vw,1.8rem);color:${CREAM};line-height:1.4;font-style:italic;margin-bottom:1.2rem}
  .hero-quote-attr{font-size:.78rem;color:rgba(245,240,232,.55);letter-spacing:.06em;text-transform:uppercase}
  .hero-pill{background:rgba(200,240,96,.12);border:1px solid rgba(200,240,96,.25);border-radius:.8rem;padding:1rem 1.2rem;margin-top:1.2rem;max-width:260px}
  .section{padding:5rem 8vw}
  .section.dark{background:${G}}
  .section.warm{background:${WARM}}
  .section-label{font-size:.7rem;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#7ab828;margin-bottom:.8rem}
  .section.dark .section-label{color:rgba(200,240,96,.55)}
  .section-h2{font-family:'Inter',sans-serif;font-size:clamp(1.8rem,3vw,3rem);color:${G};line-height:1.15;letter-spacing:-.02em;margin-bottom:1rem}
  .section.dark .section-h2{color:${CREAM}}
  .section-lead{font-size:.95rem;line-height:1.75;color:${MUTED};max-width:58ch;margin-bottom:3rem}
  .section.dark .section-lead{color:rgba(245,240,232,.6)}
  .accordion{display:flex;flex-direction:column;gap:.8rem;margin-top:1rem}
  .acc-item{background:#fff;border-radius:1.2rem;border:1px solid rgba(26,58,42,.08);overflow:hidden;transition:box-shadow .2s}
  .acc-item.open{box-shadow:0 8px 30px rgba(26,58,42,.1)}
  .acc-header{display:flex;align-items:center;justify-content:space-between;padding:1.4rem 1.8rem;cursor:pointer;user-select:none}
  .acc-header:hover{background:rgba(26,58,42,.02)}
  .acc-title{display:flex;align-items:center;gap:1rem;font-weight:700;font-size:1rem;color:${G}}
  .acc-icon{font-size:1.6rem}
  .acc-arrow{font-size:1.2rem;color:${MUTED};transition:transform .3s;flex-shrink:0}
  .acc-item.open .acc-arrow{transform:rotate(180deg)}
  .acc-body{padding:0 1.8rem 1.8rem;display:none}
  .acc-item.open .acc-body{display:block}
  .acc-text{font-size:.9rem;line-height:1.75;color:${MUTED};margin-bottom:1.2rem}
  .acc-photo{width:100%;border-radius:.8rem;object-fit:cover;max-height:300px;margin-top:1rem}
  .acc-steps{display:flex;flex-wrap:wrap;gap:.6rem;margin-top:1rem}
  .acc-step{background:${G};color:${LIME};padding:.4rem .9rem;border-radius:2rem;font-size:.78rem;font-weight:600}
  .acc-highlights{display:grid;grid-template-columns:repeat(3,1fr);gap:.8rem;margin-top:1.2rem}
  .acc-hl{background:rgba(26,58,42,.04);border-radius:.8rem;padding:1rem;text-align:center}
  .acc-hl-num{font-family:'Inter',sans-serif;font-size:2rem;color:${G};line-height:1}
  .acc-hl-l{font-size:.75rem;color:${MUTED};margin-top:.2rem}
  .team-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:1.5rem;margin-top:2rem}
  .team-card{background:#fff;border-radius:1.2rem;padding:2rem;text-align:center;border:1px solid rgba(26,58,42,.07);transition:transform .2s}
  .team-card:hover{transform:translateY(-3px)}
  .team-avatar{width:80px;height:80px;border-radius:50%;background:${G};display:flex;align-items:center;justify-content:center;font-family:'Inter',sans-serif;font-size:2rem;color:${LIME};margin:0 auto 1rem}
  .team-name{font-weight:700;font-size:1rem;color:${G};margin-bottom:.3rem}
  .team-role{font-size:.82rem;color:${MUTED}}
  .team-members-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:.9rem;margin-top:1.5rem}
  .team-member-card{background:#fff;border-radius:1rem;padding:1.2rem 1rem;text-align:center;border:1px solid rgba(26,58,42,.07);transition:transform .2s}
  .team-member-card:hover{transform:translateY(-2px)}
  .stats-row{display:grid;grid-template-columns:repeat(4,1fr);gap:1.2rem;margin-bottom:3rem}
  .stat-card{background:#fff;border-radius:1.2rem;padding:1.8rem 1.5rem;text-align:center;border:1px solid rgba(26,58,42,.06);transition:transform .2s}
  .stat-card:hover{transform:translateY(-3px)}
  .stat-card.accent{background:${G}}
  .stat-card.accent .ec-n{color:${LIME}}
  .stat-card.accent .ec-l{color:rgba(245,240,232,.55)}
  .ec-n{font-family:'Inter',sans-serif;font-size:3.2rem;color:${G};line-height:1}
  .ec-l{font-size:.78rem;color:${MUTED};margin-top:.4rem;line-height:1.4}
  .winwin{background:linear-gradient(135deg,#7ab828,${G} 60%);border-radius:1.4rem;padding:2.5rem 3rem;display:flex;align-items:center;gap:3rem;margin-top:2rem}
  .winwin-text h3{font-family:'Inter',sans-serif;font-size:1.6rem;color:${CREAM};margin-bottom:.7rem;font-style:italic}
  .winwin-text p{font-size:.87rem;color:rgba(245,240,232,.65);line-height:1.65}
  .winwin-badges{display:flex;flex-direction:column;gap:.6rem;flex-shrink:0}
  .wbadge{background:rgba(255,255,255,.1);border:1px solid rgba(255,255,255,.18);border-radius:.5rem;padding:.5rem 1rem;font-size:.8rem;color:${CREAM};font-weight:600;white-space:nowrap}
  .kontakt-grid{display:grid;grid-template-columns:1fr 1fr;gap:3rem;align-items:center}
  .kontakt-item{display:flex;align-items:center;gap:1rem;margin-bottom:1.2rem}
  .kontakt-icon{width:2.5rem;height:2.5rem;background:${G};border-radius:.6rem;display:flex;align-items:center;justify-content:center;font-size:1.2rem;flex-shrink:0}
  .kontakt-label{font-size:.75rem;color:${MUTED};margin-bottom:.15rem}
  .kontakt-val{font-weight:600;color:#fff;font-size:.9rem}
  .kontakt-right{background:${G};border-radius:1.4rem;padding:2.5rem;text-align:center}
  .kontakt-right h3{font-family:'Inter',sans-serif;font-size:1.8rem;color:${CREAM};margin-bottom:.8rem;font-style:italic}
  .kontakt-right p{font-size:.88rem;color:rgba(245,240,232,.6);margin-bottom:1.5rem;line-height:1.6}
  .hamburger{display:none;flex-direction:column;gap:5px;cursor:pointer;border:none;background:none;padding:.4rem}
  .hamburger span{display:block;width:22px;height:2px;background:#1a3a2a;border-radius:2px;transition:transform .25s,opacity .25s}
  .mob-menu{display:none;position:fixed;top:3.8rem;left:0;right:0;background:#f5f0e8;border-bottom:2px solid rgba(26,58,42,.12);padding:1.2rem 6vw 1.6rem;z-index:200;flex-direction:column;gap:0;box-shadow:0 4px 20px rgba(26,58,42,.1)}
  .mob-menu.open{display:flex}
  .mob-link{font-size:.95rem;font-weight:600;letter-spacing:.05em;text-transform:uppercase;color:#1a3a2a;cursor:pointer;border:none;background:none;padding:.85rem 0;border-bottom:1px solid rgba(26,58,42,.07);text-align:left;width:100%;transition:color .15s}
  .mob-link:hover{color:#7ab828}
  .mob-cta{background:#1a3a2a;color:#c8f060;padding:.85rem;border-radius:2rem;font-size:.9rem;font-weight:700;border:none;cursor:pointer;margin-top:.9rem;width:100%}
  @media(max-width:820px){
    html,body{overflow-x:hidden}
    .nav-links{display:none}
    .nav-cta{display:none}
    .hamburger{display:flex}
    .hero{grid-template-columns:1fr}
    .hero-r{min-height:200px}
    .hero-l{padding:2.5rem 5vw}
    .hero-stats{gap:1rem;flex-wrap:wrap}
    .stats-row{grid-template-columns:1fr 1fr}
    .team-grid{grid-template-columns:1fr}
    .team-members-grid{grid-template-columns:1fr 1fr}
    .kontakt-grid{grid-template-columns:1fr}
    .winwin{flex-direction:column;gap:1.2rem;padding:1.5rem}
    .section{padding:2.5rem 5vw}
    .acc-highlights{grid-template-columns:1fr 1fr}
    .hero-pill{max-width:100%}
    .hero-r-inner{padding:1.5rem}
    .mob-companies{grid-template-columns:1fr 1fr!important}
  }
  @media(max-width:500px){
    .acc-highlights{grid-template-columns:1fr}
    .mob-companies{grid-template-columns:1fr!important}
    .team-members-grid{grid-template-columns:1fr 1fr}
  }
`;

const COMPANIES = ["Stadtmüller","ElektroBrenner","Rewe","Agrarmarkt Engert","Köbig","Furniture","Rechtsanwalt","BASF","Back- und Brauhaus Drayß","Autohaus Jakob und Morweiser","Autohaus Kohl","Reisebüro","Immowien","Versicherung","Persönlichkeitsworkshop","Finanzworkshop","Bewerbungscoaching","RhConstruction","Brillenschlange","Caritas","Mittendrin","Kita St. Peter","Sima Bau","Demokratieworkshop","GS Wärmesysteme","Bäcker Blüm","VR Bank","Sparkasse","KVHS Workshops"];

function AccordionItem({ icon, title, children, id }) {
  const [open, setOpen] = useState(false);
  return (
    <div id={id} className={`acc-item${open?" open":""}`}>
      <div className="acc-header" onClick={() => setOpen(!open)}>
        <div className="acc-title"><span className="acc-icon">{icon}</span>{title}</div>
        <span className="acc-arrow">▾</span>
      </div>
      <div className="acc-body">{children}</div>
    </div>
  );
}

const KAT_COLORS = {
  "Handwerk / Bau":["#fef3c7","#92400e"],
  "Handwerk / Technik":["#dbeafe","#1e40af"],
  "Industrie / Produktion":["#f3e8ff","#6b21a8"],
  "Automotive":["#fee2e2","#991b1b"],
  "Handel":["#d1fae5","#065f46"],
  "Gastronomie":["#ffedd5","#9a3412"],
  "Finanz":["#e0f2fe","#0c4a6e"],
  "Tourismus":["#fce7f3","#831843"],
  "Recht":["#f0fdf4","#14532d"],
  "Bildung / Soziales":["#ede9fe","#4c1d95"],
};

const KATEGORIEN = ["Alle","Handwerk / Bau","Handwerk / Technik","Industrie / Produktion","Automotive","Handel","Gastronomie","Finanz","Tourismus","Recht","Bildung / Soziales"];

function CompanyGrid() {
  const [aktiv, setAktiv] = React.useState("Alle");
  const filtered = aktiv === "Alle" ? COMPANY_DATA : COMPANY_DATA.filter(c => c.kategorie === aktiv);
  return (
    <div>
      <div style={{display:"flex",flexWrap:"wrap",gap:".5rem",marginBottom:"1.5rem"}}>
        {KATEGORIEN.map(k=>(
          <button key={k} onClick={()=>setAktiv(k)} style={{padding:".35rem .9rem",borderRadius:"2rem",fontSize:".78rem",fontWeight:600,border:"1.5px solid",borderColor:aktiv===k?"#1a3a2a":"rgba(26,58,42,.15)",background:aktiv===k?"#1a3a2a":"#fff",color:aktiv===k?"#c8f060":"#6b6b5a",cursor:"pointer",transition:"all .18s"}}>{k}</button>
        ))}
      </div>
      <div className="mob-companies" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"1rem"}}>
        {filtered.map(co=>{
          const [bg,text] = KAT_COLORS[co.kategorie]||["#f3f4f6","#374151"];
          return (
            <div key={co.name} style={{background:"#fff",borderRadius:"1.2rem",padding:"1.4rem",border:"1px solid rgba(26,58,42,.07)",display:"flex",flexDirection:"column",gap:".6rem",transition:"transform .2s",cursor:"default"}}
              onMouseEnter={e=>e.currentTarget.style.transform="translateY(-3px)"}
              onMouseLeave={e=>e.currentTarget.style.transform="translateY(0)"}>
              <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:".5rem"}}>
                <div style={{fontWeight:700,fontSize:".9rem",color:G,lineHeight:1.3}}>{co.name}</div>
                <span style={{background:bg,color:text,padding:".2rem .6rem",borderRadius:"2rem",fontSize:".68rem",fontWeight:700,flexShrink:0,whiteSpace:"nowrap"}}>{co.kategorie}</span>
              </div>
              <div style={{fontSize:".8rem",color:MUTED}}>{co.branche}</div>
              {co.web
                ? <a href={co.web} target="_blank" rel="noopener noreferrer" style={{fontSize:".76rem",fontWeight:600,color:"#7ab828",textDecoration:"none",marginTop:"auto"}}>Website besuchen →</a>
                : <span style={{fontSize:".76rem",color:"rgba(26,58,42,.25)",marginTop:"auto"}}>–</span>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function HomePage({ onAnmeldung, onPage }) {
  return (
    <div>
      <div className="hero">
        <div className="hero-l">
          <div style={{display:"flex",alignItems:"center",gap:".6rem",marginBottom:"1.5rem"}}><div style={{width:"2px",height:"2rem",background:"#7ab828"}}></div><span style={{fontSize:".78rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:"#7ab828"}}>Bürstadt · Kreis Bergstraße</span></div>
          <div style={{fontFamily:"'Inter',sans-serif",fontSize:"clamp(3rem,6vw,6rem)",color:"#7ab828",fontWeight:400,lineHeight:1,marginBottom:".3rem",letterSpacing:"-.03em"}}>FitForFuture</div>
          <h1 className="hero-h1" style={{fontSize:"clamp(1.4rem,2.5vw,2.5rem)"}}>Mehr als nur <em>Berufsorientierung.</em></h1>
          <p className="hero-sub">Wir verbinden Schülerinnen und Schüler mit lokalen Unternehmen – praxisnah, auf Augenhöhe und mit echtem Mehrwert.</p>
          <div className="hero-btns">
            <button className="btn-primary" onClick={onAnmeldung}>Jetzt anmelden →</button>
            <button className="btn-secondary" onClick={() => document.getElementById("sec-programm")?.scrollIntoView({behavior:"smooth"})}>Unser Programm</button>
          </div>
          <div className="hero-stats">
            <div><div className="stat-n">30<span>+</span></div><div className="stat-l">Partnerunternehmen</div></div>
            <div><div className="stat-n">280<span>+</span></div><div className="stat-l">Schüler erreicht</div></div>
            <div><div className="stat-n">17</div><div className="stat-l">Teammitglieder</div></div>
          </div>
        </div>
        <div className="hero-r">
          <img className="hero-img" src="/foto3.jpg" alt="FitForFuture Workshop" />
          <div className="hero-r-inner">
            <p className="hero-quote">„Oft muss man nicht wegziehen – der richtige Beruf ist direkt vor der Haustür."</p>
            <p className="hero-quote-attr">— FitForFuture Gründer</p>
          </div>
        </div>
      </div>

      <div className="section" id="sec-programm">
        <div className="section-label">Unser Programm</div>
        <h2 className="section-h2">Alles was du <em style={{fontStyle:"italic"}}>wissen musst</em></h2>
        <p className="section-lead">FitForFuture besteht aus drei Säulen – klappe auf um mehr zu erfahren.</p>
        <div className="accordion">
          <AccordionItem icon="🏭" title="Unternehmens-Workshops" id="acc-workshop">
            <p className="acc-text">Zu Beginn des Schuljahres stellen wir uns in jeder Klasse vor und erklären das Projekt. Danach können sich Schülerinnen und Schüler für bis zu 5 Unternehmen anmelden. Wir holen sie von der Schule ab, begleiten sie den ganzen Tag und bringen sie wieder zurück.</p>
            <p className="acc-text">Keine Firmenbesichtigung – sondern echte Praxis: Werkzeuge anfassen, mit Azubis reden, selbst ausprobieren. Weil man nur so herausfindet, ob ein Beruf wirklich passt.</p>
            <img className="acc-photo" src="/foto4.jpg" alt="Workshop" />
            <div className="acc-steps">
              <span className="acc-step">Klassenvorstellung</span>
              <span className="acc-step">Anmeldung (max. 5)</span>
              <span className="acc-step">Abholung an der Schule</span>
              <span className="acc-step">Praxis im Unternehmen</span>
              <span className="acc-step">Rückkehr & Feedback</span>
            </div>
            <div className="acc-highlights" style={{marginTop:"1.2rem"}}>
              <div className="acc-hl"><div className="acc-hl-num">18</div><div className="acc-hl-l">Workshops 2025</div></div>
              <div className="acc-hl"><div className="acc-hl-num">5–8</div><div className="acc-hl-l">SuS pro Gruppe</div></div>
              <div className="acc-hl"><div className="acc-hl-num">30+</div><div className="acc-hl-l">Partnerunternehmen</div></div>
            </div>
          </AccordionItem>
          <AccordionItem icon="✨" title="Beyond-School-Workshops" id="acc-beyond">
            <p className="acc-text">Das Schulsystem deckt nicht alles ab. Deshalb bieten wir ergänzende Workshops zu Themen an, die fürs Leben wirklich wichtig sind – aber im Unterricht oft fehlen.</p>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".7rem",marginTop:"1rem"}}>
              {[["💰","Finanzworkshop","Konten, Steuern, Altersvorsorge"],["🧠","Persönlichkeitsworkshop","Stärken erkennen & nutzen"],["🏛️","Demokratieworkshop","Im Landtag vor Ort"],["📝","Bewerbungsworkshop","Anschreiben, Lebenslauf, Interview"],["👔","Style-Workshop","Auftreten & erste Wirkung"]].map(([ic,t,d])=>(
                <div key={t} style={{background:"rgba(26,58,42,.04)",borderRadius:".8rem",padding:"1rem",display:"flex",gap:".7rem",alignItems:"flex-start"}}>
                  <span style={{fontSize:"1.4rem"}}>{ic}</span>
                  <div><div style={{fontWeight:700,fontSize:".88rem",color:G,marginBottom:".2rem"}}>{t}</div><div style={{fontSize:".78rem",color:MUTED}}>{d}</div></div>
                </div>
              ))}
            </div>
          </AccordionItem>
          <AccordionItem icon="💬" title="Mentoring-Programm" id="acc-mentoring">
            <p className="acc-text">Mentoren aus unserem Netzwerk begleiten Schülerinnen und Schüler über einen längeren Zeitraum individuell – als persönliche Ansprechpartner auf Augenhöhe.</p>
            <p className="acc-text">Sie geben Einblicke in ihren eigenen Werdegang, helfen bei Bewerbungen, Studien- und Berufswahl und stehen bei persönlichen Fragen zur Seite. Denn Mentoring ist mehr als Wissensweitergabe – es ist ein echter Perspektivwechsel.</p>
            <div style={{background:G,borderRadius:"1rem",padding:"1.5rem",marginTop:"1.2rem"}}>
              <p style={{fontFamily:"'Inter',sans-serif",fontSize:"1.3rem",color:CREAM,fontStyle:"italic",lineHeight:1.5}}>"Du wirst gesehen. Du wirst begleitet. Du bist wichtig."</p>
              <p style={{fontSize:".78rem",color:"rgba(245,240,232,.45)",marginTop:".5rem",letterSpacing:".06em",textTransform:"uppercase"}}>— FitForFuture Mentoring</p>
            </div>
          </AccordionItem>
          <AccordionItem icon="📊" title="Über das Projekt">
            <p className="acc-text">FitForFuture wurde von drei Freunden gegründet, die gemeinsam die Grundschule besucht und 2023 ihr Abitur in Lampertheim absolviert haben. Dank der Unterstützung von Rüdiger Engert und der Bürgerstiftung Bürstadt konnten wir unser Herzensprojekt umsetzen.</p>
            <p className="acc-text">Im ersten Zyklus 2025 haben wir 18 Workshops mit über 400 Anmeldungen bei rund 280 Schülerinnen und Schülern durchgeführt. Ein zweiter Zyklus folgt direkt nach den Osterferien.</p>
            <img className="acc-photo" src="/foto1.jpg" alt="Präsentation" style={{marginTop:"1rem"}} />
          </AccordionItem>
        </div>
      </div>

      <div className="section warm">
        <div className="section-label">Wer wir sind</div>
        <h2 className="section-h2">Das <em style={{fontStyle:"italic"}}>Team</em></h2>
        <p className="section-lead">Drei Freunde aus Bürstadt, die etwas verändern wollen – und 14 Teammitglieder, die das möglich machen.</p>
        <div className="team-grid">
          {[["M","Mika Willwohl","https://www.linkedin.com/in/mika-willwohl-7b0b98193"],["B","Mika Back","https://www.linkedin.com/in/mika-back-057b47286"],["L","Luigi Imperato","https://www.linkedin.com/in/luigi-flavio-imperato-2462292a9"]].map(([a,n,r])=>(
            <div className="team-card" key={n}>
              <div className="team-avatar">{a}</div>
              <div className="team-name">{n}</div>
              <div className="team-role">Gründer</div>
              {r && <a href={r} target="_blank" rel="noopener noreferrer" style={{display:"inline-block",marginTop:".6rem",background:"#0077b5",color:"#fff",padding:".3rem .8rem",borderRadius:"2rem",fontSize:".75rem",fontWeight:600,textDecoration:"none"}}>LinkedIn →</a>}
            </div>
          ))}
        </div>
        <div style={{display:"flex",alignItems:"center",gap:"1rem",margin:"2.5rem 0 1.5rem"}}>
          <div style={{flex:1,height:"1px",background:"rgba(26,58,42,.1)"}}></div>
          <span style={{fontSize:".7rem",fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:MUTED}}>Teammitglieder</span>
          <div style={{flex:1,height:"1px",background:"rgba(26,58,42,.1)"}}></div>
        </div>
        <div className="team-members-grid">
          {TEAM_MEMBERS.map(({name,li})=>{
            const ini=name.split(" ").map(w=>w[0]).join("").slice(0,2);
            return (
              <div className="team-member-card" key={name}>
                <div style={{width:48,height:48,borderRadius:"50%",background:"rgba(26,58,42,.06)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1rem",fontWeight:700,color:G,margin:"0 auto .65rem"}}>{ini}</div>
                <div style={{fontWeight:600,fontSize:".85rem",color:G,lineHeight:1.3,marginBottom:".25rem"}}>{name}</div>
                <div style={{fontSize:".75rem",color:MUTED}}>Teammitglied</div>
                {li && <a href={li} target="_blank" rel="noopener noreferrer" style={{display:"inline-block",marginTop:".5rem",background:"#0077b5",color:"#fff",padding:".2rem .65rem",borderRadius:"2rem",fontSize:".7rem",fontWeight:600,textDecoration:"none"}}>LinkedIn →</a>}
              </div>
            );
          })}
        </div>
      </div>

      <div className="section warm">
        <div className="section-label">Unsere Partner</div>
        <h2 className="section-h2">30+ Unternehmen <em style={{fontStyle:"italic"}}>aus Bürstadt</em></h2>
        <p className="section-lead">Lokale Betriebe die ausbilden, duale Studiengänge anbieten und echte Chancen eröffnen – direkt vor der Haustür.</p>
        <CompanyGrid />
      </div>

      <div className="section">
        <div className="section-label">Einblicke</div>
        <h2 className="section-h2">FitForFuture <em style={{fontStyle:"italic"}}>in Aktion</em></h2>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gridTemplateRows:"260px 260px",gap:"1rem",marginTop:"2rem"}}>
          <img src="/F.jpg" alt="FitForFuture Workshop" style={{width:"100%",height:"100%",objectFit:"cover",borderRadius:"1.2rem",gridRow:"1 / 3"}} />
          <img src="/rewe.jpg" alt="REWE Workshop" style={{width:"100%",height:"100%",objectFit:"cover",borderRadius:"1.2rem"}} />
          <img src="/Lui.jpg" alt="Team" style={{width:"100%",height:"100%",objectFit:"cover",borderRadius:"1.2rem"}} />
          <img src="/ger.jpg" alt="Workshop Praxis" style={{width:"100%",height:"100%",objectFit:"cover",borderRadius:"1.2rem"}} />
          <img src="/foto4.jpg" alt="Praxis" style={{width:"100%",height:"100%",objectFit:"cover",borderRadius:"1.2rem"}} />
        </div>
      </div>

      <div className="section">
        <div className="section-label">Zahlen & Erfolge</div>
        <h2 className="section-h2">Was wir bisher <em style={{fontStyle:"italic"}}>erreicht haben</em></h2>
        <div className="stats-row">
          <div className="stat-card accent"><div className="ec-n">18</div><div className="ec-l">Workshops Zyklus 1 / 2025</div></div>
          <div className="stat-card"><div className="ec-n">400+</div><div className="ec-l">Anmeldungen von SuS</div></div>
          <div className="stat-card"><div className="ec-n">280</div><div className="ec-l">Teilnehmende Schüler</div></div>
          <div className="stat-card"><div className="ec-n">30+</div><div className="ec-l">Partnerunternehmen</div></div>
        </div>
        <div className="winwin">
          <div className="winwin-text" style={{flex:1}}>
            <h3>Eine echte Win-Win-Situation</h3>
            <p>Durch die Workshops wurden bereits längere Praktika vereinbart. Die Hemmschwelle sinkt – erste Kontakte entstehen, Bewerbungen folgen. Unternehmen die Azubis suchen profitieren genauso wie die Schüler selbst.</p>
          </div>
          <div className="winwin-badges">
            <div className="wbadge">✓ Schüler profitieren</div>
            <div className="wbadge">✓ Unternehmen profitieren</div>
            <div className="wbadge">✓ Region profitiert</div>
          </div>
        </div>
      </div>

      <div className="section dark" id="sec-kontakt">
        <div className="section-label">Kontakt</div>
        <h2 className="section-h2">Schreib uns <em style={{fontStyle:"italic"}}>einfach</em></h2>
        <div className="kontakt-grid">
          <div>
            <p className="section-lead">Ob Schüler, Elternteil, Lehrer oder Unternehmen – schreib uns einfach. Wir freuen uns!</p>
            <div className="kontakt-item">
              <div className="kontakt-icon">📧</div>
              <div><div className="kontakt-label">E-Mail</div><div className="kontakt-val">fit4future2024@outlook.de</div></div>
            </div>
            <div className="kontakt-item">
              <div className="kontakt-icon">📱</div>
              <div><div className="kontakt-label">Telefon / WhatsApp</div><div className="kontakt-val">015224932896</div></div>
            </div>
            <div className="kontakt-item">
              <div className="kontakt-icon">📍</div>
              <div><div className="kontakt-label">Standort</div><div className="kontakt-val">Bürstadt, Kreis Bergstraße</div></div>
            </div>
            <div className="kontakt-item">
              <div className="kontakt-icon">🏫</div>
              <div><div className="kontakt-label">Partnerschule</div><div className="kontakt-val">Erich-Kästner-Schule Bürstadt</div></div>
            </div>
          </div>
          <div className="kontakt-right">
            <h3>Mach mit!</h3>
            <p>Sichere dir deinen Workshop-Platz oder werde Partner – wir melden uns schnell!</p>
            <button className="btn-primary" onClick={onAnmeldung} style={{fontSize:"1rem",padding:".9rem 2rem"}}>Jetzt anmelden →</button>
          </div>
        </div>
      </div>

      <div style={{background:"#111",padding:"2rem 8vw",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:"1rem"}}>
        <div style={{display:"flex",alignItems:"center",gap:".7rem"}}>
          <img src="/logo.png" alt="Logo" style={{height:"1.8rem"}} />
          <span style={{fontFamily:"'Inter',sans-serif",color:"#fff",fontSize:"1.1rem"}}>FitForFuture</span>
        </div>
        <div style={{fontSize:".78rem",color:"rgba(255,255,255,.35)"}}>© 2025 FitForFuture · Bürstadt · Unterstützt durch Bürgerstiftung Bürstadt</div>
      </div>
    </div>
  );
}

function SuccessScreen({ data, onBack }) {
  return (
    <div className="page">
      <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",textAlign:"center",padding:"4rem 2rem",minHeight:"60vh"}}>
        <div style={{fontSize:"4rem",marginBottom:"1.5rem"}}>🎉</div>
        <h2 style={{fontFamily:"'Inter',sans-serif",fontSize:"2.2rem",color:G,marginBottom:".8rem"}}>Anmeldung eingegangen!</h2>
        <p style={{color:MUTED,fontSize:".95rem",lineHeight:1.65,maxWidth:"44ch",marginBottom:"2rem"}}>Hey {data.vorname}, deine Anmeldung ist bei uns eingegangen. Wir melden uns bald!</p>
        <div style={{display:"flex",flexWrap:"wrap",gap:".5rem",justifyContent:"center",marginBottom:"2rem"}}>
          {data.companies.map(c=><span key={c} style={{background:G,color:LIME,padding:".3rem .8rem",borderRadius:"2rem",fontSize:".78rem",fontWeight:600}}>{c}</span>)}
        </div>
        <p style={{fontSize:".82rem",color:MUTED,marginBottom:"1.5rem"}}>Klasse {data.klasse} · {data.schulart}</p>
        <button className="btn-primary" onClick={onBack}>← Zurück zur Startseite</button>
      </div>
    </div>
  );
}

const ADMIN_PW = "fff2025";
function AdminPage({ registrations }) {
  const [authed, setAuthed] = useState(false);
  const [pw, setPw] = useState("");
  const [pwErr, setPwErr] = useState(false);
  const [search, setSearch] = useState("");
  const [dbRegs, setDbRegs] = useState([]);
  const [statuses, setStatuses] = useState({});

  useEffect(() => {
    if (authed) {
      supabase.from("anmeldungen").select("*").order("id",{ascending:false}).then(({data})=>{
        if (data) setDbRegs(data);
      });
    }
  }, [authed]);

  const login = () => { if (pw===ADMIN_PW){setAuthed(true);setPwErr(false);}else{setPwErr(true);} };

  if (!authed) return (
    <div className="page" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div style={{maxWidth:380,width:"100%",padding:"2rem",textAlign:"center"}}>
        <div style={{fontSize:"3rem",marginBottom:"1.2rem"}}>🔒</div>
        <h2 style={{fontFamily:"'Inter',sans-serif",fontSize:"1.8rem",color:G,marginBottom:".5rem"}}>Admin-Bereich</h2>
        <p style={{fontSize:".88rem",color:MUTED,marginBottom:"1.5rem"}}>Nur für FitForFuture-Team.</p>
        <input type="password" placeholder="Passwort" value={pw}
          onChange={e=>{setPw(e.target.value);setPwErr(false);}} onKeyDown={e=>e.key==="Enter"&&login()}
          style={{width:"100%",padding:".7rem 1rem",border:"1.5px solid rgba(26,58,42,.2)",borderRadius:".7rem",fontFamily:"'Inter',sans-serif",fontSize:"1rem",color:G,background:"#fff",outline:"none",textAlign:"center",letterSpacing:".1em",marginBottom:".8rem"}}/>
        {pwErr && <div style={{fontSize:".8rem",color:"#c0392b",marginBottom:".8rem"}}>Falsches Passwort.</div>}
        <button onClick={login} style={{width:"100%",padding:".75rem",background:G,color:LIME,border:"none",borderRadius:".7rem",fontFamily:"'Inter',sans-serif",fontSize:".92rem",fontWeight:700,cursor:"pointer"}}>Einloggen</button>
      </div>
    </div>
  );

  const allRegs = dbRegs.length > 0 ? dbRegs : registrations;
  const filtered = allRegs.filter(r => {
    const q = search.toLowerCase();
    return !q || `${r.vorname} ${r.nachname} ${r.handy||""} ${r.companies||""}`.toLowerCase().includes(q);
  });

  return (
    <div className="page" style={{padding:"1.5rem 5vw 4rem"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"2rem",flexWrap:"wrap",gap:"1rem"}}>
        <div style={{fontFamily:"'Inter',sans-serif",fontSize:"1.8rem",color:G}}>Dashboard</div>
        <button onClick={()=>setAuthed(false)} style={{background:"transparent",border:"1px solid rgba(26,58,42,.2)",color:MUTED,padding:".4rem .9rem",borderRadius:".5rem",fontSize:".8rem",cursor:"pointer"}}>Ausloggen</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:"1rem",marginBottom:"2rem"}}>
        <div style={{background:G,borderRadius:"1rem",padding:"1.4rem"}}><div style={{fontSize:"2.4rem",color:LIME}}>{allRegs.length}</div><div style={{fontSize:".75rem",color:"rgba(245,240,232,.55)"}}>Anmeldungen</div></div>
        <div style={{background:"#fff",borderRadius:"1rem",padding:"1.4rem",border:"1px solid rgba(26,58,42,.07)"}}><div style={{fontSize:"2.4rem",color:G}}>{[...new Set(allRegs.map(r=>r.klasse))].length}</div><div style={{fontSize:".75rem",color:MUTED}}>Klassen</div></div>
        <div style={{background:"#fff",borderRadius:"1rem",padding:"1.4rem",border:"1px solid rgba(26,58,42,.07)"}}><div style={{fontSize:"2.4rem",color:G}}>{allRegs.reduce((s,r)=>s+(r.companies||"").split(", ").filter(Boolean).length,0)}</div><div style={{fontSize:".75rem",color:MUTED}}>Workshop-Wuensche</div></div>
      </div>
      <input placeholder="🔍 Suchen…" value={search} onChange={e=>setSearch(e.target.value)}
        style={{padding:".5rem .9rem",border:"1.5px solid rgba(26,58,42,.15)",borderRadius:".6rem",fontFamily:"'Inter',sans-serif",fontSize:".85rem",color:G,background:"#fff",outline:"none",marginBottom:"1.2rem",minWidth:"200px"}}/>
      <div style={{background:"#fff",borderRadius:"1.2rem",border:"1px solid rgba(26,58,42,.07)",overflow:"hidden"}}>
        {filtered.length===0?(
          <div style={{padding:"4rem",textAlign:"center",color:MUTED}}>Noch keine Anmeldungen.</div>
        ):(
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead><tr style={{background:G}}>
              {["Name","Klasse","Kontakt","Unternehmen","Status"].map(h=><th key={h} style={{padding:".7rem 1rem",textAlign:"left",fontSize:".75rem",fontWeight:700,letterSpacing:".06em",textTransform:"uppercase",color:LIME}}>{h}</th>)}
            </tr></thead>
            <tbody>
              {filtered.map((r,i)=>(
                <tr key={r.id||i} style={{borderBottom:"1px solid rgba(26,58,42,.06)"}}>
                  <td style={{padding:".75rem 1rem",fontSize:".85rem",color:G}}><strong>{r.vorname} {r.nachname}</strong><div style={{fontSize:".78rem",color:MUTED}}>{r.schulart}</div></td>
                  <td style={{padding:".75rem 1rem",fontSize:".85rem",color:G}}>{r.klasse}{r.lehrer&&<div style={{fontSize:".78rem",color:MUTED}}>Lk: {r.lehrer}</div>}</td>
                  <td style={{padding:".75rem 1rem",fontSize:".85rem",color:G}}>{r.handy||"–"}</td>
                  <td style={{padding:".75rem 1rem"}}><div style={{display:"flex",flexWrap:"wrap",gap:".3rem"}}>{(r.companies||"").split(", ").filter(Boolean).map(c=><span key={c} style={{background:"rgba(26,58,42,.08)",borderRadius:".4rem",padding:".15rem .5rem",fontSize:".72rem",fontWeight:600,color:G}}>{c}</span>)}</div></td>
                  <td style={{padding:".75rem 1rem"}}>
                    <select style={{border:"none",background:"transparent",fontSize:".78rem",cursor:"pointer",fontFamily:"'Inter',sans-serif"}}
                      value={statuses[r.id||i]||r.status||"neu"} onChange={e=>setStatuses({...statuses,[r.id||i]:e.target.value})}>
                      <option value="neu">🟢 Neu</option>
                      <option value="erledigt">✅ Erledigt</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

function Nav({ setPage }) {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const go = (p) => {
    setMenuOpen(false);
    if (p === "kontakt") { setPage("home"); setTimeout(()=>document.getElementById("sec-kontakt")?.scrollIntoView({behavior:"smooth"}),100); }
    else setPage(p);
  };
  const links = [["Workshops","workshops"],["Beyond School","beyond"],["Mentoring","mentoring"],["Kooperationen","kooperation"],["Kontakt","kontakt"]];
  return (
    <>
      <nav className="nav">
        <div className="nav-logo" onClick={()=>{setPage("home");setMenuOpen(false);}}>
          <img src="/logo.png" alt="Logo" />
          <span className="nav-logo-text">Fit<span>For</span>Future</span>
        </div>
        <div className="nav-links">
          {links.map(([l,p])=><button key={p} className="nav-link" onClick={()=>go(p)}>{l}</button>)}
        </div>
        <div style={{display:"flex",gap:".5rem",alignItems:"center"}}>
          <button className="nav-cta" onClick={()=>{setPage("anmeldung");setMenuOpen(false);}}>Jetzt anmelden</button>
          <button onClick={()=>setMenuOpen(!menuOpen)} style={{display:"flex",flexDirection:"column",justifyContent:"center",gap:"5px",cursor:"pointer",border:"1.5px solid #1a3a2a",background:"#fff",padding:".5rem .6rem",borderRadius:".5rem",zIndex:200,position:"relative"}}>
            <span style={{display:"block",width:"20px",height:"2px",background:"#1a3a2a",borderRadius:"2px"}}/>
            <span style={{display:"block",width:"20px",height:"2px",background:"#1a3a2a",borderRadius:"2px"}}/>
            <span style={{display:"block",width:"20px",height:"2px",background:"#1a3a2a",borderRadius:"2px"}}/>
          </button>
        </div>
      </nav>
      {menuOpen && (
        <div style={{position:"fixed",top:"4.5rem",left:0,right:0,background:"rgba(245,240,232,.98)",backdropFilter:"blur(12px)",padding:"1rem 5vw 1.5rem",borderBottom:"1px solid rgba(26,58,42,.1)",zIndex:99,display:"flex",flexDirection:"column",gap:".3rem"}}>
          {links.map(([l,p])=>(
            <button key={p} onClick={()=>go(p)} style={{fontSize:".95rem",fontWeight:600,color:"#1a3a2a",padding:".8rem 0",borderBottom:"1px solid rgba(26,58,42,.06)",cursor:"pointer",border:"none",background:"none",textAlign:"left",width:"100%"}}>{l}</button>
          ))}
          <button onClick={()=>{setPage("anmeldung");setMenuOpen(false);}} style={{fontSize:".95rem",fontWeight:700,color:"#7ab828",padding:".8rem 0",background:"none",border:"none",textAlign:"left",cursor:"pointer"}}>→ Jetzt anmelden</button>
          <button onClick={()=>{setPage("admin");setMenuOpen(false);}} style={{fontSize:".82rem",color:"#6b6b5a",padding:".5rem 0",background:"none",border:"none",textAlign:"left",cursor:"pointer"}}>Admin</button>
        </div>
      )}
    </>
  );
}

export default function App() {
  const [page, setPage] = useState("home");
  const [menuOpen, setMenuOpen] = useState(false);
  const [successData, setSuccessData] = useState(null);
  const [registrations, setRegistrations] = useState([]);
  const handleSuccess = (data) => { setRegistrations(prev=>[data,...prev]); setSuccessData(data); setPage("success"); };
  useEffect(()=>{ window.scrollTo(0,0); },[page]);
  return (
    <>
      <style>{css}</style>
      <nav className="nav">
        <div className="nav-logo" onClick={()=>setPage("home")}>
          <img src="/logo.png" alt="FitForFuture Logo" />
          <span className="nav-logo-text">Fit<span>For</span>Future</span>
        </div>
        <div className="nav-links">
          <button className="nav-link" onClick={()=>setPage("home")}>Start</button>
          <button className="nav-link" onClick={()=>setPage("workshops")}>Workshops</button>
          <button className="nav-link" onClick={()=>setPage("beyond")}>Beyond School</button>
          <button className="nav-link" onClick={()=>setPage("mentoring")}>Mentoring</button>
          <button className="nav-link" onClick={()=>setPage("kooperation")}>Kooperationen</button>
          <button className="nav-link" onClick={()=>{setPage("home");setTimeout(()=>document.getElementById("sec-kontakt")?.scrollIntoView({behavior:"smooth"}),100);}}>Kontakt</button>
        </div>
        <div style={{display:"flex",gap:".5rem",alignItems:"center"}}>
          <button className="nav-cta" onClick={()=>setPage("anmeldung")}>Jetzt anmelden</button>
          <button className="hamburger" onClick={()=>setMenuOpen(function(m){return !m;})}>
            <span style={{transform:menuOpen?"rotate(45deg) translate(5px,5px)":"none"}}></span>
            <span style={{opacity:menuOpen?0:1}}></span>
            <span style={{transform:menuOpen?"rotate(-45deg) translate(5px,-5px)":"none"}}></span>
          </button>
        </div>
      </nav>
      <div className={"mob-menu"+(menuOpen?" open":"")}>
        <button className="mob-link" onClick={function(){setPage("home");setMenuOpen(false);}}>Start</button>
        <button className="mob-link" onClick={function(){setPage("workshops");setMenuOpen(false);}}>Workshops</button>
        <button className="mob-link" onClick={function(){setPage("beyond");setMenuOpen(false);}}>Beyond School</button>
        <button className="mob-link" onClick={function(){setPage("mentoring");setMenuOpen(false);}}>Mentoring</button>
        <button className="mob-link" onClick={function(){setPage("home");setMenuOpen(false);setTimeout(function(){var el=document.getElementById("sec-kontakt");if(el)el.scrollIntoView({behavior:"smooth"});},150);}}>Kontakt</button>
        <button className="mob-cta" onClick={function(){setPage("anmeldung");setMenuOpen(false);}}>Jetzt anmelden</button>
      </div>
      <div className="page">
        {page==="home" && <HomePage onAnmeldung={()=>setPage("anmeldung")} onPage={setPage} />}
        {page==="anmeldung" && <Anmeldung onSuccess={handleSuccess} />}
        {page==="success" && successData && <SuccessScreen data={successData} onBack={()=>setPage("home")} />}
        {page==="admin" && <AdminPage registrations={registrations} />}
        {page==="workshops" && <WorkshopPage onBack={()=>setPage("home")} onAnmeldung={()=>setPage("anmeldung")} />}
        {page==="beyond" && <BeyondSchoolPage onBack={()=>setPage("home")} />}
        {page==="mentoring" && <MentoringPage onBack={()=>setPage("home")} />}
        {page==="kooperation" && <KooperationPage onBack={()=>setPage("home")} />}
      </div>
    </>
  );
}
